import {UIGameCardContainerView} from '../../../../shared/scripts/ui_game/ui_game_card/UIGameCardContainerView'
import {UIGamePopupConfirmationButtons} from '../../../../shared/scripts/ui_game/ui_game_popup/UIGamePopupConfirmationButtons'
import {UIGamePopupSelectCardToGiveToAnotherPlayer} from '../../../../shared/scripts/ui_game/ui_game_popup/UIGamePopupSelectCardToGiveToAnotherPlayer'

export class UIWGamePopupSelectCardToGiveToAnotherPlayer extends UIGamePopupSelectCardToGiveToAnotherPlayer {
    protected createSelectedCardContainer() {
        const w = this.canvas.popupWidth
        const h = this.canvas.itemSize * 0.75
        const selectCardContainerY = this.popupImageAndDescription.y + this.popupImageAndDescription.height
        this.selectedCardContainer = new UIGameCardContainerView(this.uiGameManager, 0, selectCardContainerY, w, h, this)
    }

    protected createConfirmationButtons() {
        const clickedCheckAction = () => this.checkAction()
        const clickedCancelAction = () => undefined

        const w = this.canvas.popupWidth
        const bottomButtonH = this.canvas.itemSize * 0.55
        const bottomButtonY = this.absoluteHeight
        this.confirmationButtons = new UIGamePopupConfirmationButtons(0, bottomButtonY, w, bottomButtonH, clickedCheckAction, clickedCancelAction, this)
        this.selectCardFormat.selectCardFormat.cancelButtonActive ? this.confirmationButtons.showCancelButton() : this.confirmationButtons.hideCancelButton()
    }

    protected setContainerY() {
        this.y = this.canvas.appH - this.canvas.itemSize - this.absoluteHeight
    }

    protected createPlayerCardContainer() {
        const playerCardContainerX = 0
        const playerCardContainerH = this.canvas.itemSize
        const playerCardContainerY = this.absoluteHeight
        const playerCardContainerW = this.canvas.appW - this.canvas.itemSize * 10

        this.playerCardContainer = new UIGameCardContainerView(this.uiGameManager, playerCardContainerX, playerCardContainerY, playerCardContainerW, playerCardContainerH, this, false, false)
    }
}
